import { Injectable } from '@angular/core';
import { DominioCombo } from '@core/models/dominio';
import { ApiService } from './api.service';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'ufs';
const route = {
  listar: `${baseRef}/todos`,
  listarPorCidade: (idCidade: number) => `${baseRef}/${idCidade}`
}

@Injectable({
  providedIn: 'root'
})
export class UFService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listar(idCidade?: number) {
    if (idCidade) {
      const key = route.listarPorCidade(idCidade);
      return this.domainCache.getOrLoad(key, () =>
        this.apiService.get<DominioCombo[]>(key, undefined, undefined, true)
      );
    }

    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<DominioCombo[]>(route.listar, undefined, undefined, true)
    );
  }
}
